import { authorisedPersonsRepo } from "./authorisedPersons.repo";
import { IOvlascenaLicaPayload } from "./authorisedPersons.types";

class AuthorisedPersonsService {
  getSvaOvlascenaLicaZaPreuzimanjeMarkica = () => {
    return authorisedPersonsRepo.getSvaOvlascenaLicaZaPreuzimanjeMarkica();
  };

  postKreirajOvlascenoLiceZaPreuzimanjeMarkica = (
    payload: IOvlascenaLicaPayload
  ) => {
    return authorisedPersonsRepo.postKreirajOvlascenoLiceZaPreuzimanjeMarkica(
      payload
    );
  };

  putIzmeniOvlascenoLiceZaPreuzimanjeMarkica = (
    payload: IOvlascenaLicaPayload,
    id: number
  ) => {
    return authorisedPersonsRepo.putIzmeniOvlascenoLiceZaPreuzimanjeMarkica(
      payload,
      id
    );
  };
}

export const authorisedPersonsService = new AuthorisedPersonsService();
